import http from "../utils/http";

function request(url, method = "get", data = {}, headers = {}) {
  return http({
    url,
    method,
    data,
    headers
  });
}

function post(url, data = {}, headers = {}) {
  return request(url, "post", data, headers);
}

const api = {
  imageUrl: process.env.VUE_APP_BASH_URL,
  formatImageUrl(url) {
    const bashImageUrl = this.imageUrl;
    return bashImageUrl + url;
  },
  formatVtrackUrl(url) {
    const vtrackImageUrl = "https://api.vtrack.top";
    return vtrackImageUrl + url;
  },
  formatVideoUrl(url) {
    var videoUrl = "";
    if (this.imageUrl == 'https://api.vtrack.top/') {
      videoUrl = "https://image.vancheen.com/VideoUpload/";
    } else {
      videoUrl = "http://192.168.0.40:8086/VideoUpload/"
    }
    return videoUrl + url;
  },
  formatVancheenUrl(url) {
    var imageUrl = "";
    if (this.imageUrl == 'https://api.vtrack.top/') {
      imageUrl = "https://image.vancheen.com/ImgUpload/";
    } else {
      imageUrl = "http://192.168.0.40:8086/ImgUpload/"
    }
    return imageUrl + url;
  },
  home: {
    loadPurchasingSystemHome: data => {
      return post("/Purchasing/LoadPurchasingSystemHome", data);
    },
    cozeChatPage: data => {
      return post("/Purchasing/CozeChatPage", data);
    },
    cozeChat: data => {
      return post("/Purchasing/CozeChat", data);
    },
  },
  product: {
    loadShopProductsByPage: data => {
      return post("/Purchasing/LoadShopProductsByPage", data);
    },
    loadProductInfo: data => {
      return post("/Purchasing/LoadProductInfo", data);
    },
    addShopCar: data => {
      return post("/Purchasing/AddShopCar", data);
    }
  },
  user: {
    login(data) {
      return post("/Login/PurchasingSystemLogin", data);
    },
    register(data) {
      return post("/Login/PurchasingSystemRegister", data);
    },
    sendVerificationCode(data) {
      return post("/Home/SendSMS", data);
    },
    userSMSVerification(data) {
      return post("/User/UserSMSVerification", data);
    },
    getCustomerPersonalInfo(data) {
      return post("/Purchasing/GetCustomerPersonalInfo", data);
    },
    editCustomerPersonalInfo(data) {
      return post("/Purchasing/EditCustomerPersonalInfo", data);
    },
    getTakeDeliveryCountryCityList(data) {
      return post("/EntrustOrder/GetTakeDeliveryCountryCityList", data);
    },
    getCustomerPointChangeRecordListByPage(data) {
      return post("/Purchasing/GetCustomerPointChangeRecordListByPage", data);
    },
    checkCustomerCompanyNameExists(data) {
      return post("/Purchasing/CheckCustomerCompanyNameExists", data);
    },
    uploadImgFile: data => {
      return post("/Home/UniversalUploadPic", data);
    },
  },
  address: {
    addCustomerReceiving(data) {
      return post("/Purchasing/AddCustomerReceiving", data);
    },
    getCustomerReceivingList(data) {
      return post("/Purchasing/GetCustomerReceivingList", data);
    },
    editCustomerReceiving(data) {
      return post("/Purchasing/EditCustomerReceiving", data);
    },
    deleteCustomerReceiving(data) {
      return post("/Purchasing/DeleteCustomerReceiving", data);
    },
  },
  inquiry: {
    getCargoLogisticsListByPage(data) {
      return post("/Purchasing/GetCargoLogisticsListByPage", data);
    },
    getCargoLogisticsInfo(data) {
      return post("/Purchasing/GetCargoLogisticsInfo", data);
    },
  },
  customerManagement: {
    getFreightPriceListByPage(data) {
      return post("/Purchasing/GetFreightPriceListByPage", data);
    },
    loadFreightPriceInfo(data) {
      return post("/Purchasing/LoadFreightPriceInfo", data);
    },
  },
  order: {
    customerOrderCountStatistics(data) {
      return post("/Purchasing/CustomerOrderCountStatistics", data);
    },
    addCustomerOrderCargoPreInput(data) {
      return post("/Purchasing/AddCustomerOrderCargoPreInput", data);
    },
    editCustomerOrder(data) {
      return post("/Purchasing/EditCustomerOrder", data);
    },
    deleteCustomerOrder(data) {
      return post("/Purchasing/DeleteCustomerOrder", data);
    },
    getCustomerOrderListByPage(data) {
      return post("/Purchasing/GetCustomerOrderListByPage", data);
    },
    getCustomerOrderHasShippedListByPage(data) {
      return post("/Purchasing/GetCustomerOrderHasShippedListByPage", data);
    },
    getCustomerPayBillList(data) {
      return post("/Purchasing/GetCustomerPayBillList", data);
    },
    getCustomerPayBillListByNuclearAccountNo(data) {
      return post("/Purchasing/GetCustomerPayBillListByNuclearAccountNo", data);
    },
    getPayBillDetail(data) {
      return post("/Purchasing/GetPayBillDetail", data);
    },
    customerOrderChooseTakeDeliveryType(data) {
      return post("/Purchasing/CustomerOrderChooseTakeDeliveryType", data);
    },
    getOrderDeliveryExceptionHandlingByWB_Id(data) {
      return post("/Purchasing/GetOrderDeliveryExceptionHandlingByWB_Id", data);
    },
    saveOrderExceptionHandlingByWB_Id(data) {
      return post("/Purchasing/SaveOrderExceptionHandlingByWB_Id", data);
    },
    paymentCollectionBill(data) {
      return post("/Purchasing/PaymentCollectionBill", data);
    },
    getProcurementQuotationUnitList(data) {
      return post("/Procurement/GetProcurementQuotationUnitList", data);
    },
    taxCalculator(data) {
      return post("/Purchasing/TaxCalculator", data);
    },
    translateText(data) {
      return post("/Purchasing/TranslateText", data);
    }
  },
  account: {
    getCustomerFundUseDetailAndAvailableFundList(data) {
      return post("/Purchasing/GetCustomerFundUseDetailAndAvailableFundList", data);
    },
    getSystemAvailableCurrencyList(data) {
      return post("/FinancialBills/GetSystemAvailableCurrencyList", data);
    },
  },
  calculator: {
    freightPriceCalculator(data) {
      return post("/Purchasing/FreightPriceCalculator", data);
    }
  },
  system: {
    tokenRefresh: data => {
      return post("/Login/TokenRefresh", data, { 'Token-Refresh': true });
    }
  }
};

export default api;
